<template>
  <div>
    <vx-card>
      <div class="vx-row mb-3">
        <div class="vx-col w-1/2 md:mb-0">
          <small class="label">Category</small>
          <v-select :clearable="false" placeholder="" v-model="tag_details.category_id" :reduce="option => option.id" label="name"
            :options="category_list" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="onInputSelectTag()"/>
        </div>
      </div>
      <!-- <div class="vx-row mb-3">
        <div class="vx-col w-1/2 md:mb-0">
          <small class="label">Select Available Help Guide</small>
          <v-select :clearable="false" placeholder="" v-model="selected_tag" :reduce="option => option" label="name"
            :options="available_help_tags" :dir="$vs.rtl ? 'rtl' : 'ltr'" @input="onInputSelectTag()"/>
        </div>
      </div> -->
      <div class="vx-row">
        <div class="vx-col w-1/2">
          <small class="label">Name <span class="text-danger">*</span></small>
          <vs-input class="w-full mb-3" v-model="tag_details.name"></vs-input>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-1/2 md:mb-0">
          <quill-editor v-model="tag_details.data"></quill-editor>
        </div>
      </div>
      <div class="vx-row mb-3">
        <div class="vx-col w-1/2 md:mb-0">
          <small class="label">Guide Videos</small>
          <span v-for="(link, index) in tag_details.links" :key="index">
            <vs-input class="w-full mb-3" v-model="link.url" ></vs-input>
          </span>
          <vs-button class="mt-4" size="small" icon-pack="feather" icon="icon-plus" @click.stop="onClickAddVideo">
            add video
          </vs-button>
        </div>
      </div>

      <div class="flex flex-wrap items-center justify-end mt-8">
        <vs-button button="submit" @click.stop="onClickSave" class="mt-2 ml-auto">Create</vs-button>
      </div>

    </vx-card>
  </div>
</template>

<script>
import { RepositoryFactory } from "@/repository/RepositoryFactory";
import ErrorMessages from "@/mixins/ErrorMessages";
import SuccessMessage from "@/mixins/SuccessMessage";
import { help_tag_list } from "@/constants/help-tags";
const HelpTagRepository = RepositoryFactory.get('helpTag')
import vSelect from 'vue-select'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import { quillEditor } from 'vue-quill-editor'

export default {
  name: "CreateHelperTag",
  data() {
    return {
      tag_details: {
        name: '',
        data: '',
        links: [
          { url: '' }
        ],
        slug: 'create-batch',
      },
      help_tag_id: '',
      content: '',
      existing_help_tags: [],
      available_help_tags: [],
      selected_tag: {},
      category_list: []
    }
  },
  components: {
    quillEditor,
    'v-select': vSelect,
  },
  mixins: [ErrorMessages, SuccessMessage],
  async mounted() {
    this.help_tag_id = this.$route.params.id
    await this.fetchExistingHelpTags()
    await this.fetchHelpTagCategories()

    let toolbarElement = document.querySelector('.ql-toolbar');
    if (toolbarElement) {
      let matches = toolbarElement.querySelectorAll('button');
      for (let el of matches) {
        this.showTooltips(el, toolbarElement);
      }
    }
  },
  methods: {
    onClickAddVideo() {
      this.tag_details.links.push({ url: '' })
    },
    async fetchExistingHelpTags() {
      this.$vs.loading()
      try {
        const { data } = await HelpTagRepository.get(this.page, 50)
        this.existing_help_tags = data.data.map((x) => x.slug)
        this.available_help_tags = help_tag_list.filter((x) => !this.existing_help_tags.includes(x.slug))
      } catch (e) {
        console.log(e.message);
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close()
    },
    async onClickSave() {
      try {
        // this.tag_details.slug = this.selected_tag.slug
        this.tag_details.slug = ''
        this.tag_details.links = this.tag_details.links.filter((x) => x.url.length > 0).map((x) => x.url)
        await HelpTagRepository.createHelpTag(this.tag_details)
        this.$router.push('/pages/help-tags')
        this.showSuccessMessage('Help tag created esuccessfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickStatusChange(status) {
      try {
        await HelpTagRepository.statusChangeHelpTag(this.help_tag_id, status)
        await this.fetchExistingHelpTags()
        this.showSuccessMessage('Help tag status updated successfully')
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    showTooltips(el, toolbarElement) {
      let tooltips = {
        'font': 'Select a font',
        'size': 'Select a font size',
        'header': 'Select the text style',
        'bold': 'Bold',
        'blockquote': 'Blockquote',
        'code-block': 'Code Block',
        'italic': 'Italic',
        'list': 'List',
        'script': 'Script',
        'indent': 'Indent',
        'direction': 'Direction',
        'underline': 'Underline',
        'video': 'Insert a video',
        'strike': 'Strikethrough',
        'color': 'Select a text color',
        'background': 'Select a background color',
        'align': 'Text alignment',
        'link': 'Insert a link',
        'image': 'Insert an image',
        'formula': 'Insert a formula',
        'clean': 'Clear format',
        'add-table': 'Add a new table',
        'table-row': 'Add a row to the selected table',
        'table-column': 'Add a column to the selected table',
        'remove-table': 'Remove selected table',
        'help': 'Show help'
      };
      let tool = el.className.replace('ql-', '');
      if (tooltips[tool]) {
        toolbarElement.querySelector(`button.ql-${tool}`).setAttribute('title', tooltips[tool]);
      }
    },
    onInputSelectTag() {
      this.tag_details.name = this.selected_tag.name
    },
    async fetchHelpTagCategories() {
      try {
        const { data } = (await HelpTagRepository.getTagCategories(1, 150)).data
        this.category_list = data
      } catch (error) {
        this.convertAndNotifyError(error)
      }
    },
  },
}
</script>

<style scoped></style>